import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'src/shared/components/form/checkbox';
import { List } from 'src/shared/components/list';
export function SelectAll({ classes }) {
    const { t } = useTranslation();
    const { watch, setValue } = useFormContext();
    const isAllClassesSelected = watch('classes').length === classes.length;
    function selectAll() {
        if (isAllClassesSelected) {
            // remove
            setValue('classes', [], { shouldValidate: true, shouldDirty: true });
            return;
        }
        // add
        const classIds = classes.map((classItem) => classItem.hashId);
        setValue('classes', classIds, { shouldValidate: true, shouldDirty: true });
    }
    return (_jsx(List.Item, { children: _jsx("div", { className: "flex w-full items-center border-b-small border-neutral-200 py-4", children: _jsx(Checkbox, { onChange: selectAll, id: "select-all-classes", checked: isAllClassesSelected, labelClassName: "text-small text-neutral-900 pt-[0.125rem]", label: t('modules.form.classes.select_all') }) }) }));
}
